/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateOrderRequest } from '../../models/create-order-request';
import { CreateOrderResult } from '../../models/create-order-result';

export interface PostOrders$Params {
  body?: CreateOrderRequest;
}

export function postOrders(
  http: HttpClient,
  rootUrl: string,
  params?: PostOrders$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<CreateOrderResult>> {
  const rb = new RequestBuilder(rootUrl, postOrders.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateOrderResult>;
    }),
  );
}

postOrders.PATH = '/Orders';
